{
	"title": "Athletes",
	"subtitle": "Every athlete approved in GMS and everyone entered in {{games}}. Click a row to open the athlete.",
	"detailTitle": "Athlete",
	"gender": {
		"MALE": "Male",
		"FEMALE": "Female",
		"unknown": "Not given"
	},
	"filters": {
		"label": "Filter the athletes",
		"name": "Athlete name",
		"noc": "NOC",
		"allNocs": "All NOCs",
		"sport": "Sport",
		"allSports": "All sports",
		"event": "Event",
		"allEvents": "All events",
		"pickSportFirst": "Pick a sport first",
		"gender": "Gender",
		"anyGender": "Any gender"
	},
	"table": {
		"athlete": "Athlete",
		"noc": "NOC",
		"gender": "Gender",
		"sports": "Sports",
		"events": "Events",
		"notEntered": "Not entered",
		"medals": "Medals",
		"open": "Open {{name}}",
		"count_one": "{{n}} athlete",
		"count_other": "{{n}} athletes"
	},
	"empty": {
		"filteredTitle": "No athletes match these filters",
		"filteredBody": "Clear a filter, or reset them all to see every athlete.",
		"reset": "Reset filters",
		"noneTitle": "No athletes in {{games}} yet",
		"noneBody": "An athlete appears here once GMS approves their registration, or once they are on the roster of an entry.",
		"noGamesTitle": "No games are set up yet",
		"noGamesBody": "Games are created in GMS. Ask your administrator."
	},
	"errors": {
		"gamesTitle": "The games could not load"
	},
	"detail": {
		"loading": "Loading the athlete…",
		"notFoundTitle": "This athlete is not in {{games}}",
		"notFoundBody": "Switch games in the sidebar, or find the athlete in the list.",
		"backToList": "All athletes",
		"facts": {
			"gender": "Gender",
			"sports": "Sports",
			"entries": "Entries"
		},
		"bibs": {
			"title": "Numbers",
			"subtitle": "Typed once per sport: every start list, team and line-up of that sport shows it, unless an event, a team or a meet has its own.",
			"loading": "Loading numbers…",
			"error": "The numbers could not be loaded. Reload the page.",
			"none": "Enter the athlete in an event first: a number is kept per sport.",
			"placeholder": "Bib",
			"save": "Save",
			"saved": "{{label}} {{bib}} saved for {{sport}}.",
			"cleared": "{{label}} cleared for {{sport}}.",
			"readOnly": "You cannot change numbers in this sport.",
			"notUsed": "No number in this sport",
			"uniqueNoc": "Each team of a NOC may use this number once, so other NOCs can wear it too.",
			"uniqueSport": "Only one athlete in this sport may hold this number."
		},
		"entries": {
			"title": "Entries",
			"subtitle_one": "{{n}} entry in {{games}}. Click a row to open the entry and its roster.",
			"subtitle_other": "{{n}} entries in {{games}}. Click a row to open the entry and its roster.",
			"truncated": "Showing the first {{shown}} of {{total}} entries.",
			"event": "Event",
			"entry": "Entry",
			"noc": "NOC",
			"role": "Role",
			"bib": "Bib",
			"status": "Status",
			"medal": "Medal",
			"individual": "Individual",
			"eventMeets": "Meets of {{event}}",
			"open": "Open the entry in {{event}}",
			"none": "Not entered in any event yet."
		},
		"medals": {
			"title": "Medals",
			"none": "No medals awarded yet.",
			"awarded": "Awarded {{when}}",
			"openEntry": "Open the entry"
		}
	}
}
